<template>
  <SwapableStep>
    <slot />
  </SwapableStep>
</template>

<script>
import SwapableStep from '../../netherlands/Steps/SwappableStep.vue';

export default {
  components: { SwapableStep },
};
</script>
